import React from 'react'
import posed from 'react-pose'
import { IntlShape, injectIntl } from 'react-intl'

import { CloseIcon } from 'src/components/UI/Icon/Icon'

import styles from './SizeChart.module.scss'
import { sizes } from './sizes'
import messages from './messages'

const Background = posed.div({
  init: { opacity: 0 },
  active: { opacity: 0.6 },
})

const Wrapper = posed.div({
  init: { transform: 'translateX(150%)' },
  active: { transform: 'translateX(0%)' },
})

type Props = {
  handleClick: () => void
  type: string
  intl: IntlShape
}

const SizeChart = ({ handleClick, type, intl }: Props) => {
  // @ts-ignore
  const size: any = sizes[type]

  if (!size) {
    return null
  }

  const showCm = !!(
    type == 'infantFootwearUgg' ||
    type == 'toddlerFootwearUgg' ||
    type == 'kidsFootwearUgg'
  )

  const { formatMessage } = intl

  return (
    <div>
      <Background
        onClick={handleClick}
        initialPose="init"
        pose="active"
        className={styles.background}
      />
      <Wrapper initialPose="init" pose="active" className={styles.wrapper}>
        <button onClick={handleClick} className={styles.close}>
          <CloseIcon width={32} color="black" />
        </button>
        <span className={styles.heading}>
          {formatMessage(messages.sizeGuide)}
        </span>
        {size && (
          <span className={styles.title}>{formatMessage(size.title)}</span>
        )}
        <table>
          <thead>
            <tr>
              <th>US</th>
              <th>EUR</th>
              {showCm && <th>CM</th>}
            </tr>
          </thead>
          <tbody>
            {size &&
              size.items.map((s: any, index: number) => (
                <tr key={s.us}>
                  <td>{s.us}</td>
                  <td>{s.eur}</td>
                  {showCm && <td>{s.cm}</td>}
                </tr>
              ))}
          </tbody>
        </table>
      </Wrapper>
    </div>
  )
}

export default injectIntl(SizeChart)
